
export default {
  name: "Comment",
  props: {
    userName: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    stars: {
      type: Number
    },
    comment: {
      type: String,
      required: true
    },
    contentName: {
      type: String,
      required: true
    },
    userImage: {
      type: String,
      required: true
    },
    label: {
      type: String
    }
  }
};
